const Checkout = {
  makePayment: 'Checkout',
  makePaymentPinpad: 'AgencyCheckout',
  getInfoBpe: (paymentId: string) => `/externalsale/GetBpeInfo?paymentId=${paymentId}`,
  createPaymentLink: 'Checkout/CreatePaymentLink',
};

export default Checkout;
